export default __webpack_public_path__ + "static/media/txt3_sp.9b648d66.png";